module.exports = __webpack_public_path__ + "img/202413-xl.17db4113.png";